// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".create-dialog[data-v-4cec7294] {\n  min-width: 480px;\n}\n.create-dialog .body-card[data-v-4cec7294] {\n  padding: 54px 0;\n  background-color: white;\n}\n.create-dialog .wrap-progress-circular[data-v-4cec7294] {\n  width: 80px;\n  height: 80px;\n}", ""]);
// Exports
module.exports = exports;
